<template>
  <b-container>
    <evaluations-list :title="'label_sideMenu_evaluation_administrator_evaluations_title'" :isReportsList="false" :is-organization-list="true" />
  </b-container>
</template>
<script >
import EvaluationsList from "../shared/EvaluationsList";
export default {
  name: "EvaluationsListOrganization",
  components: {EvaluationsList},
};
</script >
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="sass" scoped >

@import "../../../../assets/css/variables"

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px

.cardContainer h5
  text-align: center
  width: 100%

h2
  color:  black
  margin: 1em 0
legend
  font-weight: bold
  font-size: 14px !important

h4
  font-size: 1.3rem
  text-transform: uppercase
</style >
